import React from 'react';
// import {Button} from '@material-ui/core';
import { Link } from 'react-router-dom';
// import {FaEye} from 'react-icons/fa';
import InfoDownload from '../../assets/images/pr.png';
import moment from 'moment';
import News from '../../models/news.model';
import { lang } from '../../config/app.config';
var adbs = require("ad-bs-converter");

interface InfoProps {
  data: News,
  prefix: string
}

const InfoCard: React.FC<InfoProps> = (props) => {
  const { data, prefix } = props;
  let date = moment(data.created_at).format('yyyy/MM/DD');
  let convertedDate = adbs.ad2bs(date)
  let npObj = data?.translations.find(obj => {
    return obj.locale === 'np';
  })
  let enObj = data?.translations.find(obj => {
    return obj.locale === 'en';
  })

  console.log('data here', data)

  let title = lang === 'np' ? npObj?.title : enObj?.title;
  if (!title || title === '') {
    title = npObj?.title ?? enObj?.title;
  }
  return (
    < div className="info-card">
      <div className="info-logo">
        <img src={InfoDownload} alt="" />
      </div>
      <div className="info-details">
        <p className="text-16-primary">
          <Link to={`/${lang}/${prefix}/${data.slug}`} className="text-15-primary" target="_blank" rel="noreferrer">{title}</Link></p>
        <p className="text-13-grey dev-number">{`${convertedDate?.en?.year}/${convertedDate?.en?.month}/${convertedDate?.en?.day}`}</p>
      </div>
      {/* <div className="info-download">
        <Button className="btn-trans-black">
          <Link to={`/${lang}/${prefix}/${data.slug}`} target="_blank" rel="noreferrer"><FaEye/></Link>
        </Button>
      </div> */}
    </div>
  );
}

export default InfoCard;